const RadioButton = ({
  formik,
  label,
  value,
  isRadioSelected,
  handleRadioClick,
  stateToCompare,
  setState,
  fieldName,
}) => {
  return (
    <div className="d-flex items-center mg-top-10 radio-button-container">
      <input
        type="radio"
        value={value}
        className="mg-right-10"
        checked={isRadioSelected(value, stateToCompare)}
        onChange={(e) => handleRadioClick(e, setState)}
      />
      <p className="fs-18 semi-bold mg-left-5">{label}</p>
    </div>
  );
};

export default RadioButton;
